/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

window.currentMobileTab = 'school'
window.mobileMenuVisible = false

function resetMenu () {
  $('.nav-school').removeClass('visible')
  $('.nav-district').removeClass('visible')
  $('.nav-mobile').removeClass('visible')
  $('#nav-toggle').removeClass('active')
  window.mobileMenuVisible = false

  if (window.currentMobileTab === 'school' && $('body').hasClass('district-page')) {
    window.currentMobileTab = 'district'
  }

  setMobileTab(window.currentMobileTab, false)
}

function setMobileTab (tab, interactive) {
  window.currentMobileTab = tab
  const nonActiveTab = tab === 'school' ? 'district' : 'school'

  $('#nav-toggle-' + tab).addClass('active')
  $('#nav-toggle-' + nonActiveTab).removeClass('active')

  if (interactive) {
    if (tab === 'district') {
      $('.nav-district').addClass('visible')
      $('.nav-school').removeClass('visible')
    } else {
      $('.nav-district').removeClass('visible')
      $('.nav-school').addClass('visible')
    }
  }
}

function toggleMobileNav () {
  const $navMobile = $('.nav-mobile')
  const $navToggle = $('#nav-toggle')

  if (!window.mobileMenuVisible) {
    setMobileTab(window.currentMobileTab, true)
    $navMobile.addClass('visible')
    $navToggle.addClass('active')
    window.mobileMenuVisible = true
  } else {
    $('.nav-school').removeClass('visible')
    $('.nav-district').removeClass('visible')
    $navMobile.removeClass('visible')
    $navToggle.removeClass('active')
    window.mobileMenuVisible = false
  }
}

resetMenu()

$(document).on('click', '.nav-item', function () {
  if (window.mobileMenuVisible) {
    toggleMobileNav()
  }
})
